export default "__VITE_ASSET__D$G0LVSX__"